"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomGreetings_1 = __importDefault(require("./CustomGreetings"));
const BulkAssign_1 = __importDefault(require("./BulkAssign"));
const Extensions_1 = __importDefault(require("./Extensions"));
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/call-recording`;
    }
    /**
     * Returns call recording settings.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates current call recording settings.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyInfo
     */
    async put(callRecordingSettingsResource, restRequestConfig) {
        const r = await this.rc.put(this.path(), callRecordingSettingsResource, undefined, restRequestConfig);
        return r.data;
    }
    extensions() {
        return new Extensions_1.default(this);
    }
    bulkAssign() {
        return new BulkAssign_1.default(this);
    }
    customGreetings(greetingId = null) {
        return new CustomGreetings_1.default(this, greetingId);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map